if (!customElements.get('cro-cart-rewards')) {
  customElements.define('cro-cart-rewards', class extends HTMLElement {
    connectedCallback() {
      const currency = this.dataset.currency;
      const platform = window.Shopify?.currency;
      const rate = currency === this.dataset.baseCurrency ? 1 :
        platform?.active === currency ? Number(platform.rate) : NaN;
      const total = Number(this.dataset.total);
      if (!Number.isFinite(rate) || rate <= 0 || !Number.isFinite(total)) {
        this.hidden = true;
        return;
      }
      let format;
      try {
        format = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency });
      } catch (_) {
        this.hidden = true;
        return;
      }
      // Shopify's cart API uses hundredths even for zero-decimal currencies.
      const money = amount => format.format(amount / 100);
      const steps = [...this.querySelectorAll('[data-reward-step]')].map(step => {
        const threshold = Math.round(Number(step.dataset.threshold) * rate);
        const reached = total >= threshold;
        step.dataset.reached = String(reached);
        step.querySelector('.cro-reward-step__check').hidden = !reached;
        step.querySelector('.cro-reward-step__amount').textContent = money(threshold);
        step.querySelector('[data-reward-status]').textContent = reached ? this.dataset.reached : this.dataset.pending;
        return { threshold, title: step.querySelector('.cro-reward-step__title').textContent };
      });
      if (!steps.length) return;
      const next = steps.find(step => total < step.threshold);
      const goal = next || steps[steps.length - 1];
      const progress = this.querySelector('progress');
      progress.max = goal.threshold;
      progress.value = Math.min(goal.threshold, Math.max(0, total));
      this.querySelector('[data-reward-message]').textContent = next ?
        this.dataset.remaining.replace('__amount__', () => money(goal.threshold - total)).replace('__reward__', () => goal.title) :
        this.dataset.complete;
      this.hidden = false;
    }
  });
}
